// extracted by mini-css-extract-plugin
module.exports = {"mediaPlayButton":"styles-module--mediaPlayButton--1N0RY","icon":"styles-module--icon--11G-N"};